import { Component,OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/app/services/common.service';
import { organizationDTO } from 'src/app/models/providersDTO';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  title = 'BCBSCHPWeb';
  dynamicThemeCSSUrl: string;
  dynamicStyleCssUrl:string;
  public orgDetails: organizationDTO = new organizationDTO();
    contentPath = localStorage.getItem('ContentPath');
  constructor(private commonService: CommonService,public sanitizer: DomSanitizer) {
  }

  ngOnInit() {
    this.commonService.getOrganizationDetails().then((formdata) => {
      this.orgDetails = formdata[0];
      this.dynamicStyleCssUrl=this.contentPath+'/'+this.orgDetails.themeFolder+'/css/Styles.css';
      this.dynamicThemeCSSUrl=this.contentPath+'/'+this.orgDetails.themeFolder+'/css/themecolor.css';
    });
  }
}
